import React from 'react';
import Button from '@merq/web-ui/dist/components/Button';
import './styles.scss';
import GetAppIcon from '@mui/icons-material/GetAppSharp';
import { ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ExportButton: React.FC<ButtonProps> = props => {
  const { t } = useTranslation();
  return (
    <Button
      className="export-button"
      color="primary"
      variant="text"
      startIcon={<GetAppIcon className="download-icon" />}
      {...props}
    >
      <label htmlFor="">{t('export').toUpperCase()}</label>
    </Button>
  );
};

export default ExportButton;
